import {
  StatusColorMap,
  StatusLabelMap,
} from "../../../shared/components/chips/StatusChip";
import colors from "../../../shared/themes/colors";
import { OfferStatusCode } from "../../serviceOffers/models/models";
import { dt } from "../../../shared/themes/redesignTokens";

export const createReceivedOfferStatusLabelMap = (
  translate: (key: string) => string
): StatusLabelMap<OfferStatusCode> => ({
  [OfferStatusCode.draft]: translate("offerStatuses.draft"),
  [OfferStatusCode.sent]: translate("offerStatuses.sent"),
  [OfferStatusCode.viewed]: translate("offerStatuses.viewed"),
  [OfferStatusCode.negotiating]: translate("offerStatuses.negotiating"),
  [OfferStatusCode.accepted]: translate("offerStatuses.accepted"),
  [OfferStatusCode.rejected]: translate("offerStatuses.rejected"),
  [OfferStatusCode.expired]: translate("offerStatuses.expired"),
  [OfferStatusCode.withdrawn]: translate("offerStatuses.withdrawn"),
  [OfferStatusCode.awaitingConfirmation]: translate("offerStatuses.awaitingConfirmation"),
  [OfferStatusCode.confirmed]: translate("offerStatuses.confirmed"),
  [OfferStatusCode.workInProgress]: translate("offerStatuses.workInProgress"),
  [OfferStatusCode.workCompleted]: translate("offerStatuses.workCompleted"),
  [OfferStatusCode.serviceCompleted]: translate("offerStatuses.serviceCompleted"),
  [OfferStatusCode.archived]: translate("offerStatuses.archived"),
});

export const createReceivedOfferStatusColorMap = (): StatusColorMap<OfferStatusCode> => ({
  [OfferStatusCode.draft]: {
    backgroundColor: colors.backgrounds.violet,
    textColor: colors.icons.violet,
  },
  [OfferStatusCode.sent]: {
    backgroundColor: colors.primary.lightBlue3,
    textColor: dt.blue,
  },
  [OfferStatusCode.viewed]: {
    backgroundColor: colors.secondary.gray94,
    textColor: colors.secondary.gray40,
  },
  [OfferStatusCode.negotiating]: {
    backgroundColor: colors.backgrounds.orange,
    textColor: colors.icons.orange,
  },
  [OfferStatusCode.accepted]: {
    backgroundColor: colors.backgrounds.green,
    textColor: colors.primary.green,
  },
  [OfferStatusCode.rejected]: {
    backgroundColor: colors.backgrounds.red,
    textColor: colors.icons.red,
  },
  [OfferStatusCode.expired]: {
    backgroundColor: colors.secondary.gray94,
    textColor: colors.secondary.gray40,
  },
  [OfferStatusCode.withdrawn]: {
    backgroundColor: colors.secondary.gray85,
    textColor: colors.secondary.gray40,
  },
  [OfferStatusCode.awaitingConfirmation]: {
    backgroundColor: "#FEF9E7",
    textColor: "#F39C12",
  },
  [OfferStatusCode.confirmed]: {
    backgroundColor: "#E8F8F5",
    textColor: "#1ABC9C",
  },
  [OfferStatusCode.workInProgress]: {
    backgroundColor: colors.primary.lightBlue3,
    textColor: dt.blue,
  },
  [OfferStatusCode.workCompleted]: {
    backgroundColor: colors.backgrounds.green,
    textColor: colors.primary.green,
  },
  [OfferStatusCode.serviceCompleted]: {
    backgroundColor: colors.backgrounds.green,
    textColor: colors.primary.green,
  },
  [OfferStatusCode.archived]: {
    backgroundColor: colors.secondary.gray94,
    textColor: colors.secondary.gray40,
  },
});
